// extracted by mini-css-extract-plugin
export var boxItems = "_ai-1";
export var boxItemsLg = "_ai-2";
export var button = "_ai-7";
export var buttonHoverless = "_ai-9";
export var buttonLg = "_ai-8";
export var filterGroupBox = "_ai-0";
export var icon = "_ai-3";
export var iconSecondary = "_ai-6";
export var iconWrapper = "_ai-4";
export var iconWrapperLg = "_ai-5";
export var truncatedLabel = "_ai-a";